/** User mention element type */
export const USER_MENTION = 'user-mention';

/** User mention user id DOM attribute. */
export const USER_ID_ATTRIBUTE = 'data-lumapps-user-id';
